import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import {NavbarService} from '../shared/services/navbar.service';
import {Router} from '@angular/router';
import { CountryGuideService } from '../shared/services/countryGuide.service';
import { IWGSharedService } from '../shared/services/shared.service';


@Component({
  selector: 'app-country-guides',
  templateUrl: './country-guides.component.html',
    styleUrls: ['./country-guides.component.scss']
})
export class CountryGuidesComponent implements OnInit {

    constructor(
        private countryGuideService: CountryGuideService,
        private breakpointObserver: BreakpointObserver,
        public nav: NavbarService,
        public router: Router,
        private sharedService: IWGSharedService, 
    ) {
        this.breakpointObserver.observe([
            Breakpoints.XSmall,
            Breakpoints.Small,
            Breakpoints.Medium,
            Breakpoints.Large,
            Breakpoints.XLarge,
        ]).subscribe(result => {
            if (result.matches) {
                if (result.breakpoints[Breakpoints.XSmall]) {
                    this.cols = this.gridByBreakpoint.xs;
                }
                if (result.breakpoints[Breakpoints.Small]) {
                    this.cols = this.gridByBreakpoint.sm;
                }
                if (result.breakpoints[Breakpoints.Medium]) {
                    this.cols = this.gridByBreakpoint.md;
                }
                if (result.breakpoints[Breakpoints.Large]) {
                    this.cols = this.gridByBreakpoint.lg;
                }
                if (result.breakpoints[Breakpoints.XLarge]) {
                    this.cols = this.gridByBreakpoint.xl;
                }
            }
        });
    }


    cols: number;

    gridByBreakpoint = {
        xl: 5,
        lg: 5,
        md: 4,
        sm: 2,
        xs: 1
    };

    isLoading = false;
    filter: any;
    countryGuides: any;
    selectedCountryGuide: any;
    limit: any;
    timer = null;
    showFooter = true;
    embedStatus ="notembed";      

    getItems = () => {        
        this.isLoading = true;
        const param = {limit: 0, q: this.filter};        
        this.countryGuideService.getCountryGuides(param)
            .subscribe(response => {
                this.isLoading = false;
                this.countryGuides = response.data.Data;
                if (response.data.Data.length > 0) {
                    this.selectedCountryGuide = this.countryGuides[0];
                }
            }, () => {
                this.isLoading = false;
            });

    }

    search(searchStr: string): void {
        clearTimeout(this.timer);
        const time = 500;
        this.timer = setTimeout(() => {           
            this.getItems();
        }, time);
    }    

    ngOnInit(): void {   
        var isEmbed = this.sharedService.getIsEmbed();
        if (isEmbed === true) { this.embedStatus = "embed"; }
        else {           
            this.embedStatus = "notembed";
            this.nav.setActiveMenu('myGuides');
            this.nav.setActiveModuleMenu({'isVisible':true, 'activeMenu':'myGuides'});            
        }
        this.nav.show(isEmbed);
        if (isEmbed === true) {       
            history.pushState(null, null, null);       
            window.addEventListener('popstate', () => {              
                history.pushState(null, null, null);              
            });
            this.showFooter = false;
        }else{
            this.showFooter = true;
        }
        this.getItems();
    }
}
